import React, { useState } from 'react';
import clsx from 'clsx';
import IconClose from '../utils/icon/icon-close.svg';
import { useProduct } from './product-context';

const ABSORBENCY_DISCLAIMER_TEXT = '*individual results may vary';

const ProductTextBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { product } = useProduct();

  function unescapeHTML(html, removeContainer = false) {
    const escapeEl = document.createElement('textarea');
    escapeEl.innerHTML = html;
    if (removeContainer) {
      const unwrapEl = document.createElement('div');
      unwrapEl.innerHTML = escapeEl.textContent;
      return unwrapEl.firstChild?.innerHTML;
    }
    return escapeEl.textContent;
  }

  if (!product?.metafields?.absorbencyTitle) {
    return null;
  }

  const title = unescapeHTML(product?.metafields?.absorbencyTitle);
  const content = unescapeHTML(product?.metafields?.absorbencyDescription, true);

  return (
    <>
      <div
        className={clsx('relative rounded-md bg-brand-light-beige', {
          'px-5 py-4': isOpen,
          'px-2 py-0.5': !isOpen,
        })}
      >
        <h3
          className={clsx('body-3-bold text-center', {
            'sr-only': isOpen,
          })}
        >
          <button
            aria-expanded={isOpen}
            aria-controls="banner-content"
            className="rte mx-auto block text-center"
            onClick={() => setIsOpen((value) => !value)}
            dangerouslySetInnerHTML={{ __html: title }}
          ></button>
        </h3>
        <div
          className={clsx('body-3', {
            hidden: !isOpen,
          })}
          id="banner-content"
        >
          <div
            className="rte [&>:first-child]:mt-0 [&>:last-child]:mb-0"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
          <button
            aria-expanded={isOpen}
            aria-controls="banner-content"
            aria-label={window?.TMW?.Strings?.accesssibility?.close}
            className="absolute right-2.5 top-2.5 [&>svg]:size-3"
            onClick={() => setIsOpen((value) => !value)}
          >
            <IconClose />
          </button>
        </div>
      </div>
      <span className="body-3 -mb-1 -translate-y-1">{ABSORBENCY_DISCLAIMER_TEXT}</span>
    </>
  );
};

export default ProductTextBanner;
